import React from 'react';
import './home.css'
import poster from '../../images/poster.png'
import ranked from '../../images/ranked-choice.png'


const Home: React.FC = () => {
    return(
        <div className='home-background'>
            <div className='illustration padding'>
                <img className='illustration-inner' src={poster} alt="poster" />
            </div>
            <div className='fair-info'>
                <div className='fair-info-inner'>
                    <div className='fair-info-text'>
                        <h1>What is FairVote?</h1>
                        <p>FairVote is a voting platform that allows democratic organizations to select their candidates 
                            based on a Ranked Voting System that is more fair, inclusive, and representative of voters’ choices.<br/><br/>
                            FairVote allows all potential voters within the organization to cast their votes anonymously, and securely 
                            with encrypted technology by ranking their choices. <br/><br/> Our platform’s open-source backend 
                            and algorithm assures voters and poll makers of the fairness of the algorithm. <br/><br/>
                            It explains the process of ranked voting and the calculation of the results in simple English for all users 
                            with different tech knowledge levels to understand and trust in the process of voting.
                        </p>
                    </div>
                </div>
            </div>
            <div className='crv-info'>
                <div className='crv-info-inner'>
                    <div className='crv-info-text'>
                        <h1>How does Ranked Choice Voting work?</h1>
                        <p>
                            A ranked-choice voting system (RCV) is an electoral system in which voters rank candidates by preference on their ballots.<br/><br/>
                            If a candidate wins a majority of first-preference votes, they are declared the winner. <br/><br/>
                            If no candidate wins a majority of first-preference votes, the candidate with the fewest first-preference votes is eliminated. <br/><br/>
                            First-preference votes cast for the failed candidate are eliminated, lifting the second-preference choices indicated on those ballots. <br/><br/>
                            A new tally is conducted to determine whether any candidate has won a majority of the adjusted votes. <br/><br/>
                            The process is repeated until a candidate wins an outright majority.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;

